<div>
    <mat-toolbar>
        <span>Field Properties</span>
        <span class="info-drawer-toolbar-spacer"></span>
        <button mat-icon-button (click)="cancelClicked()" tabindex="-1"><mat-icon>close</mat-icon></button>
    </mat-toolbar>

    <form id="formFieldPropertiesForm" class="form-field-properties">

        <div *ngIf="field.fieldHasConfiguration" style="padding: 20px;">
            <button mat-raised-button
                    type="button"
                    color="primary"
                    title="click to configure flexible select options"
                    (click)="ConfigureFlexSelect()">
                Configure Flexible Select
            </button>
        </div>

        <mat-accordion>
            <mat-expansion-panel [expanded]="this.BasicPropertiesExpanded" class="expansion-panel">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Basic Properties
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="control-wrapper"
                     *ngIf="hasProperty('displayName')"
                     id="displayNameDiv">
                    <mat-form-field appearance="outline"
                                    [floatLabel]="'always'"
                                    subscriptSizing="dynamic">
                        <mat-label>Display Name</mat-label>
                        <input matInput
                               #displayName
                               name="field.displayName"
                               [(ngModel)]="field.displayName"
                               (ngModelChange)="this.handleModelChange('displayName')" />
                    </mat-form-field>
                    <small>The display name will appear as the control label</small>
                </div>

                <div class="control-wrapper"
                     *ngIf="hasProperty('name')">
                    <mat-form-field appearance="outline"
                                    [floatLabel]="'always'"
                                    subscriptSizing="dynamic">
                        <mat-label>Internal Name</mat-label>
                        <!--Was "field.name"-->
                        <div *ngIf="hasProperty('gridColumnBehavior')">
                            <input matInput
                                   #name
                                   name="field.name"
                                   [(ngModel)]="field.transientToBeAppliedInternalName"
                                   (ngModelChange)="this.handleModelChange('gridColumnName')" />
                        </div>
                        <div *ngIf="!hasProperty('gridColumnBehavior')">
                            <input matInput
                                   #name
                                   name="field.name"
                                   [(ngModel)]="field.transientToBeAppliedInternalName"
                                   (ngModelChange)="this.handleModelChange('name')" />
                        </div>
                    </mat-form-field>
                    <small>The field's unique internal name</small>
                    <small class="property-error-message property-red">
                        {{this.FieldNameError}}
                    </small>
                </div>

                <!-- Begin properties related to 'selectOptions'/dropdown lists. -->
                <div class="control-wrapper" *ngIf="hasProperty('selectOptions')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Named List Options Constraints</mat-label>

                        <mat-select name="field.selectOptionsConstraintName"
                                    [disabled]="this.SiteSelectOptionsConstraintsEmpty"
                                    [(value)]="this.SelectedSelectOptionsConstraintId">
                            <mat-option [value]="0">--- No Constraint Selected ---</mat-option>

                            <mat-option *ngFor="let siteSelectOptionsConstraint of this.SiteSelectOptionsConstraints"
                                        title="{{siteSelectOptionsConstraint.name}}"
                                        [value]="siteSelectOptionsConstraint.id">
                                {{siteSelectOptionsConstraint.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <small>Available list options constraints</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('selectOptions') || hasProperty('selectOptionsProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>List Options</mat-label>
                        <button matSuffix mat-icon-button
                                title="click to enter/paste a list of options"
                                class="select-options-dialog-btn"
                                (click)="selectOptionsDialog()">
                            <mat-icon class="select-options-dialog-mat-icon">assignment</mat-icon>
                        </button>

                        <input matInput
                               name="field.selectOptions"
                               [disabled]="this.SelectOptionsPropertyEditDisabled"
                               placeholder="Enter a list of options"
                               [(ngModel)]="field.selectOptions"
                               (ngModelChange)="this.handleModelChange('selectOptions')"
                               (blur)="this.handleSettingsFieldBlur($event,'selectOptions') " />
                    </mat-form-field>

                    <small>Type each choice separated by a | character (ex. oranges|grapes|bananas) or click the icon to paste in a list.</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('selectOptions') || hasProperty('selectOptionsProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>List Options Constraint Name</mat-label>

                        <button matSuffix mat-icon-button
                                title="{{this.getAssignConstraintNameButtonTitle('Assign a constraint name to this options list', this.SelectOptionsProperties, this.SelectedSelectOptionsConstraintId)}}"
                                class="select-options-dialog-btn"
                                [disabled]="this.FieldSelectOptionsEmpty"
                                (click)="this.toggleEditConstraint(this.SelectOptionsProperties, 'selectOptions')">
                            <mat-icon class="edit-select-options-mat-icon">create</mat-icon>
                        </button>

                        <input matInput
                               #selectOptionsConstraintName
                               name="field.selectOptionsConstraintName"
                               [disabled]="this.SelectOptionsNameDisabled"
                               placeholder="Enter a constraint name"
                               [(ngModel)]="field.selectOptionsConstraintName"
                               (ngModelChange)="this.handleModelChange('selectOptionsConstraintName')" />
                    </mat-form-field>
                    <small>A name for saving the list options as a constraint</small>
                    <mat-error *ngIf="this.SelectOptionsConstraintError"
                               class="range-error-message">{{this.SelectOptionsConstraintError}}</mat-error>
                </div>
                <!-- End properties related to 'selectOptions'/dropdown lists. -->
                <!--
            pharvey - 3/26/2024 - commented out for VNEXT-1153 as inline content fields no longer use iframes and use a new property
            named UrlBuilderConfigJson
            -->
                <div class="control-wrapper" *ngIf="hasProperty('iframeSource')">
                    <b>Note: </b>There is currently no UI for configuring the url (and other properties) of an Inline Content Field.
                    <!--
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Url for inline content</mat-label>
                    <input matInput
                           name="field.iframeSource"
                           [(ngModel)]="field.iframeSource"
                           (ngModelChange)="this.handleModelChange('iframeSource')" />
                </mat-form-field>
                <small>Base Url to external system</small>
                -->
                </div>

                <!-- pharv 10/29/2021 - moved this control into the "basic" expansion panel -->
                <div class="control-wrapper" *ngIf="hasProperty('required')">
                    <div class="cb-wrapper">
                        <mat-checkbox [(ngModel)]="field.required"
                                      (ngModelChange)="this.handleModelChange('required')"
                                      [checked]="field.required"
                                      name="chkRequired">Required</mat-checkbox>
                    </div>
                    <small>Require that this control contains information</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('maxLength')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Max Length</mat-label>
                        <input matInput
                               name="field.maxLength"
                               type="number"
                               [(ngModel)]="field.maxLength"
                               (ngModelChange)="this.handleModelChange('maxLength')" />
                    </mat-form-field>
                    <small>The maximum number of characters allowed for this control</small>
                </div>

                <!-- Begin properties related to 'minValue' and 'maxValue'. -->
                <div class="control-wrapper" *ngIf="hasProperty('minValue') || hasProperty('maxValue')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Named Numeric Range Constraints</mat-label>

                        <mat-select name="field.numericRangeConstraintName"
                                    [disabled]="this.SiteNumericRangeConstraintsEmpty"
                                    [(value)]="this.SelectedNumericRangeConstraintId">
                            <mat-option [value]="0">--- No Constraint Selected ---</mat-option>

                            <mat-option *ngFor="let siteConstraint of this.SiteNumericRangeConstraints"
                                        title="{{siteConstraint.name}}"
                                        [value]="siteConstraint.id">
                                {{siteConstraint.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <small>Available numeric range constraints</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('minValue') || hasProperty('minValueProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Min Value</mat-label>
                        <input matInput
                               name="field.minValue"
                               type="number"
                               [disabled]="this.NumericRangeInputFieldsDisabled"
                               [(ngModel)]="field.minValue"
                               (ngModelChange)="this.handleModelChange('minValue')" />
                    </mat-form-field>
                    <small>The lowest accepted value for this control</small>
                    <mat-error *ngIf="this.MinValueError"
                               class="range-error-message">{{this.MinValueError}}</mat-error>
                </div>
                <div class="control-wrapper" *ngIf="hasProperty('maxValue') || hasProperty('maxValueProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Max Value</mat-label>
                        <input matInput
                               name="field.maxValue"
                               type="number"
                               [disabled]="this.NumericRangeInputFieldsDisabled"
                               [(ngModel)]="field.maxValue"
                               (ngModelChange)="this.handleModelChange('maxValue')"
                               (blur)="this.handleSettingsFieldBlur($event,'minValue')" />
                    </mat-form-field>
                    <small>The highest accepted value for this control</small>
                    <mat-error *ngIf="this.MaxValueError"
                               class="range-error-message">{{this.MaxValueError}}</mat-error>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('minValue') || hasProperty('maxValue') || hasProperty('minValueProperty') || hasProperty('maxValueProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Numeric Range Constraint Name</mat-label>

                        <button matSuffix mat-icon-button
                                title="{{this.getAssignConstraintNameButtonTitle('Assign a constraint name to the entered \'minValue\' and/or \'maxValue\' range values', this.NumericRangeProperties, this.SelectedNumericRangeConstraintId)}}"
                                class="select-options-dialog-btn"
                                [disabled]="this.NumericRangeFieldsEmpty"
                                (click)="this.toggleEditConstraint(this.NumericRangeProperties, 'minValue')">
                            <mat-icon class="edit-regular-expression-mat-icon">create</mat-icon>
                        </button>

                        <input matInput
                               #numericRangeConstraintName
                               name="field.numericRangeConstraintName"
                               [disabled]="this.NumericRangeNameDisabled"
                               placeholder="Enter a constraint name"
                               [(ngModel)]="field.numericRangeConstraintName"
                               (ngModelChange)="this.handleModelChange('numericRangeConstraintName')" />
                    </mat-form-field>
                    <small>A name for saving a numeric range constraint</small>
                    <mat-error *ngIf="this.NumericRangeConstraintError"
                               class="range-error-message">{{this.NumericRangeConstraintError}}</mat-error>
                </div>
                <!-- End properties related to 'minValue' and 'maxValue'. -->
                <!-- Begin properties related to decimal fields. -->
                <div class="control-wrapper" *ngIf="hasProperty('numDigitsAfterDecimalPoint')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Number of Digits After Decimal Points</mat-label>

                        <mat-select name="field.numDigitsAfterDecimalPoint"
                                    [disabled]="false"
                                    [(value)]="field.numDigitsAfterDecimalPoint">
                            <mat-option *ngFor="let decimalPoints of this.getAllowableNumberOfDecimalPoints()"
                                        [value]="decimalPoints">
                                {{decimalPoints}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <small>Allowable # digits after the decimal point/precision</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('roundToNumDigitsAfterDecimalPoint')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Round to Number of Digits</mat-label>

                        <mat-select name="field.roundToNumDigitsAfterDecimalPoint"
                                    [disabled]="false"
                                    [(value)]="field.roundToNumDigitsAfterDecimalPoint">
                            <mat-option *ngFor="let decimalPoints of this.getAllowableNumberOfDecimalPoints(true)"
                                        [value]="decimalPoints">
                                {{decimalPoints}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <small>Round to # digits after the decimal point</small>
                </div>

                <!-- End properties related to decimal fields. -->
                <!-- Begin properties related to 'minDate' and 'maxDate'. -->
                <div class="control-wrapper" *ngIf="hasProperty('minDate') || hasProperty('maxDate')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Named Date Range Constraints</mat-label>

                        <mat-select name="field.dateRangeConstraintName"
                                    [disabled]="this.SiteDateRangeConstraintsEmpty"
                                    [(value)]="this.SelectedDateRangeConstraintId">
                            <mat-option [value]="0">--- No Constraint Selected ---</mat-option>

                            <mat-option *ngFor="let siteConstraint of this.SiteDateRangeConstraints"
                                        title="{{siteConstraint.name}}"
                                        [value]="siteConstraint.id">
                                {{siteConstraint.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <small>Available date range constraints</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('minDate') || hasProperty('minDateProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Min Date</mat-label>
                        <input matInput
                               [matDatepicker]="minDatePicker"
                               [value]="this.MinDateValue.value"
                               [disabled]="this.DateRangeInputFieldsDisabled"
                               placeholder="Minimum date"
                               (dateChange)="this.handleModelChange('minDate', $event)" />
                        <mat-datepicker-toggle matSuffix [for]="minDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #minDatePicker></mat-datepicker>
                    </mat-form-field>
                    <small>The minimum allowable date for this control</small>
                </div>
                <div class="control-wrapper" *ngIf="hasProperty('maxDate') || hasProperty('maxDateProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Max Date</mat-label>
                        <input matInput
                               [matDatepicker]="maxDatePicker"
                               [value]="this.MaxDateValue.value"
                               [disabled]="this.DateRangeInputFieldsDisabled"
                               placeholder="Maximum date"
                               (dateChange)="this.handleModelChange('maxDate', $event)"
                               (blur)="this.handleSettingsFieldBlur($event,'maxDate')" />
                        <mat-datepicker-toggle matSuffix [for]="maxDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #maxDatePicker></mat-datepicker>
                    </mat-form-field>
                    <small>The maximum allowable date for this control</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('minDate') || hasProperty('maxDate') || hasProperty('minDateProperty') || hasProperty('maxDateProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Date Range Constraint Name</mat-label>

                        <button matSuffix mat-icon-button
                                title="{{this.getAssignConstraintNameButtonTitle('Assign a constraint name to the entered \'minDate\' and/or \'maxDate\' range values', this.DateRangeProperties, this.SelectedDateRangeConstraintId)}}"
                                class="select-options-dialog-btn"
                                [disabled]="this.DateRangeFieldsEmpty"
                                (click)="this.toggleEditConstraint(this.DateRangeProperties, 'minDate')">
                            <mat-icon class="edit-regular-expression-mat-icon">create</mat-icon>
                        </button>

                        <input matInput
                               #dateRangeConstraintName
                               name="field.dateRangeConstraintName"
                               [disabled]="this.DateRangeNameDisabled"
                               placeholder="Enter a constraint name"
                               [(ngModel)]="field.dateRangeConstraintName"
                               (ngModelChange)="this.handleModelChange('dateRangeConstraintName')" />
                    </mat-form-field>
                    <small>A name for saving a date range constraint</small>
                    <mat-error *ngIf="this.DateRangeConstraintError"
                               class="range-error-message">{{this.DateRangeConstraintError}}</mat-error>
                </div>
                <!-- End properties related to 'minDate' and 'maxDate'. -->
                <!-- Begin properties related to the form template instances (home page) field. -->
                <div class="control-wrapper" *ngIf="hasProperty('formTemplate')">
                    <mat-form-field appearance="outline"
                                    [floatLabel]="'always'"
                                    *ngIf="field != null && !field.enableSimpleFormGridDisplay; else multiTemplateSelection"
                                    subscriptSizing="dynamic">
                        <mat-label>Form Template</mat-label>

                        <mat-select name="field.formTemplateId"
                                    [disabled]="false"
                                    [(value)]="field.formTemplateId"
                                    (selectionChange)="this.handleModelChange('formTemplate', $event)">
                            <mat-option [value]="0">--- No Template Selected ---</mat-option>

                            <mat-option *ngFor="let formTemplate of this.SiteFormTemplates"
                                        title="{{formTemplate.name}}"
                                        [value]="formTemplate.id">
                                {{formTemplate.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <ng-template #multiTemplateSelection>
                        <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                            <mat-label>Form Template(s)</mat-label>

                            <mat-select name="field.selectedFormTemplateIds"
                                        [disabled]="false"
                                        [(value)]="this.ArrayOfSelectedFormTemplateIds"
                                        (selectionChange)="this.handleModelChange('formTemplate', $event)" multiple>

                                <mat-option *ngFor="let formTemplate of this.SiteFormTemplates"
                                            title="{{formTemplate.name}}"
                                            [value]="formTemplate.id">
                                    {{formTemplate.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-template>


                    <small>Available form templates</small>
                    <button *ngIf="(field.formTemplateId > 0 && !field.enableSimpleFormGridDisplay) || (field.enableSimpleFormGridDisplay && field.selectedFormTemplateIds?.length > 0)"
                            class="button-primary confgure-home-page-grid-columns-btn"
                            mat-raised-button
                            (click)="openConfigureHomePageColumns()">
                        Configure Form Grid
                    </button>


                    <div class="control-wrapper" *ngIf="hasProperty('openFormInstancesInNewTab')">
                        <mat-checkbox [(ngModel)]="field.openFormInstancesInNewTab"
                                      (ngModelChange)="this.handleModelChange('openFormInstancesInNewTab')"
                                      [checked]="field.openFormInstancesInNewTab"
                                      name="chkOpenFormInstancesInNewTab">Open forms in new tab?</mat-checkbox>

                        <div><small>If checked, forms will open in a new browser tab.</small></div>
                    </div>

                    <div class="control-wrapper">
                        <mat-checkbox [(ngModel)]="field.enableSimpleFormGridDisplay"
                                      (ngModelChange)="this.handleModelChange('enableSimpleFormGridDisplay', $event)"
                                      [checked]="field.enableSimpleFormGridDisplay"
                                      name="chkEnableSimpleFormGridDisplay">Enable Simple Form Grid</mat-checkbox>

                        <div><small>Check to enable the simple display of the form grid.</small></div>
                    </div>
                    <!-- End properties related to the form template instances (home page) field. -->
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('htmlText')">
                    <div class="label-and-button">
                        <mat-label>HTML Markup</mat-label> <mat-icon class="open-html-editor" (click)="openHtmlTextDialog()" title="Click to open a larger editor">open_in_new</mat-icon>
                    </div>
                    <kendo-editor name="kendo-editor"
                                  [(ngModel)]="field.htmlText"
                                  style="height: 100%;"
                                  [iframeCss]="{ content: this.getInstructionsEditorCssDefaults() }">
                        <kendo-toolbar>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                            <kendo-toolbar-colorpicker kendoEditorForeColor [paletteSettings]="{palette:'basic'}">
                            </kendo-toolbar-colorpicker>
                        </kendo-toolbar>
                    </kendo-editor>
                    <small>HTML markup text</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('displayFormat') && displayFormatValues && (displayFormatValues.length > 0)">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Display Format</mat-label>

                        <mat-select name="field.displayFormat"
                                    [(ngModel)]="field.displayFormat"
                                    (ngModelChange)="this.handleModelChange('displayFormat')">
                            <mat-option *ngFor="let displayFormat of this.displayFormatValues"
                                        title="{{displayFormat}}"
                                        [value]="displayFormat">
                                {{displayFormat}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <small>The display format for this control</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('instructionsText')">
                    <div>Instructions</div>
                    <kendo-editor name="kendo-editor"
                                  [(ngModel)]="field.instructionsText"
                                  style="height: 100%;"
                                  [iframeCss]="{ content: this.getInstructionsEditorCssDefaults() }">
                        <kendo-toolbar>
                            <kendo-toolbar-buttongroup>
                                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                            </kendo-toolbar-buttongroup>
                            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                            <kendo-toolbar-colorpicker kendoEditorForeColor [paletteSettings]="{palette:'basic'}">
                            </kendo-toolbar-colorpicker>
                        </kendo-toolbar>
                    </kendo-editor>
                    <small>Instructions for users who enter, review data</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('roleNames')">
                    <mat-label>Selected Role(s)</mat-label>

                    <mat-selection-list #siteRoleNames
                                        name="field.selectedRoleNames"
                                        [(ngModel)]="this.SelectedRoleNames"
                                        (ngModelChange)="this.handleModelChange('selectedRoleNames')"
                                        class="role-names-mat-selection-list">
                        <mat-list-option *ngFor="let siteRoleName of this.SiteRoleNames"
                                         [value]="siteRoleName">
                            {{siteRoleName}}
                        </mat-list-option>
                    </mat-selection-list>

                    <small>One or more role names for 'Show To'/'Hide From' logic</small>
                    <mat-error *ngIf="this.DateRangeConstraintError"
                               class="range-error-message">{{this.NoRoleNameSelectedError}}</mat-error>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('imageButtons')">
                    <mat-label>Manage Images</mat-label>
                    <div>
                        <button mat-flat-button
                                class="button-primary"
                                style="width: 125px;"
                                (click)="this.openUploadImageDialogue()">
                            Upload Image ...
                        </button>

                        <button mat-flat-button
                                class="button-primary"
                                style="width: 150px; margin-left: 15px"
                                (click)="this.openListImagesDialogue()">
                            Manage Images ...
                        </button>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel *ngIf="this.hasAnyAdvancedProperty" [expanded]="this.AdvancedPropertiesExpanded" class="expansion-panel">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Advanced Properties
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- only displays if field is in a grid -->
                <div class="control-wrapper" *ngIf="isInGrid() && hasProperty('gridColumnWidth')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Grid Column Width</mat-label>
                        <input matInput
                               name="field.gridColumnWidth"
                               [(ngModel)]="field.gridColumnWidth"
                               (ngModelChange)="this.handleModelChange('gridColumnWidth')" />
                    </mat-form-field>
                    <small>The width of the column in pixels</small>
                </div>

                <!-- 01-26-2021 note:  moved this property up in this file so it displays right after min/max values. -->
                <div class="control-wrapper" *ngIf="hasProperty('defaultValue')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Default Value</mat-label>
                        <input matInput
                               name="field.defaultValue"
                               [(ngModel)]="field.defaultValue"
                               (ngModelChange)="this.handleModelChange('defaultValue')" />
                    </mat-form-field>
                    <small>The default value for this control</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('placeholderText')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Placeholder Text</mat-label>
                        <input matInput
                               name="field.placeholderText"
                               [(ngModel)]="field.placeholderText"
                               (ngModelChange)="this.handleModelChange('placeholderText')" />
                    </mat-form-field>
                    <small>Placeholder text is placed in the control prior to user input</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('toolTip')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                        <mat-label>Tool Tip</mat-label>
                        <input matInput
                               name="field.toolTip"
                               [(ngModel)]="field.toolTip"
                               (ngModelChange)="this.handleModelChange('toolTip')" />
                    </mat-form-field>
                    <small>Hover over the <mat-icon class="info-icon">info</mat-icon> icon to display this text</small>
                </div>
                <div class="control-wrapper" *ngIf="hasProperty('displayRows')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Display Rows</mat-label>
                        <input matInput
                               name="field.displayRows"
                               [(ngModel)]="field.displayRows"
                               (ngModelChange)="this.handleModelChange('displayRows')" />
                    </mat-form-field>
                    <small>The number of lines for editing or options to display in a list</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('presetFilters')">
                    <section>
                        <button mat-raised-button
                                (click)="this.presetFilterClicked()">
                            Preset Filter
                        </button>
                    </section>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('showContactsProperties')">
                    <section>
                        <ng-container *ngFor="let contactFieldName of this.ContactFieldNames; let i=index">
                            <mat-checkbox [formControl]="this.getContactFieldNameFormControl(i)"
                                          (ngModelChange)="this.handleModelChange('showContactsProperties')"
                                          class="contact-field-mat-checkbox">
                                {{contactFieldName}}
                            </mat-checkbox>
                            <ng-container *ngIf="this.isNotLastContactField(i)">
                                <br />
                            </ng-container>
                        </ng-container>
                    </section>
                    <small>Available contact fields (at least one required)</small>
                    <mat-error *ngIf="this.ContactFieldsError"
                               class="range-error-message">{{this.ContactFieldsError}}</mat-error>
                </div>

                <ng-container *ngIf="hasProperty('fixedFirstColumnFile')">
                    <div class="control-wrapper">
                        <input type="file"
                               #fixedFirstColumnFile
                               class="hidden-file-input"
                               (change)="this.onFixedFirstColumnFileChanged($event)" />

                        <button mat-stroked-button
                                (click)="this.loadFixedFirstColumnFromCsvFileClicked()">
                            Load fixed values for first column from CSV ...
                        </button>
                        <small>Load fixed values for first column from a CSV file</small>
                    </div>
                    <div class="control-wrapper">
                        <button mat-stroked-button
                                [disabled]="this.HasNoFixedFirstColumn"
                                (click)="this.clearFixedFirstColumn()">
                            Clear Fixed Values for First Column
                        </button>
                        <small>Clear fixed values for first column</small>
                    </div>
                </ng-container>

                <div class="control-wrapper" *ngIf="hasProperty('excelImportExportTemplate')">
                    <input type="file" #selectTemplateFile class="hidden-file-input"
                           (change)="this.onTemplateFileChanged($event)" />

                    <button mat-stroked-button (click)="this.loadTemplateFileClicked()" class="load-options-from-csv-button" accept=".xlsx">
                        Load Template ...
                    </button>
                    <small>Load Excel Template</small>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Start Row Index</mat-label>
                        <input matInput type="number" [(ngModel)]="field.excelImportExportTemplateStartingRowIndex" min="1"
                               name="excelImportExportTemplateStartingRowIndex"
                               title="First row is 1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Start Column Index</mat-label>
                        <input matInput type="number" [(ngModel)]="field.excelImportExportTemplateStartingColumnIndex" min="1"
                               name="excelImportExportTemplateStartingColumnIndex"
                               title="First column is 1" />
                    </mat-form-field>
                </div>

                <ng-container *ngIf="hasProperty('displayKendoGridRows')">
                    <mat-form-field appearance="outline">
                        <mat-label>Number of Grid Rows Displayed</mat-label>
                        <input matInput type="number" [(ngModel)]="field.displayKendoGridRows" min="1"
                               name="DisplayKendoGridRows" />
                    </mat-form-field>
                </ng-container>

                <div class="control-wrapoper" *ngIf="hasProperty('gridKeyColumns')">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Number of Key Column</mat-label>
                        <input matInput type="number" [(ngModel)]="field.gridKeyColumns" min="0"
                               name="gridKeyColumns" />
                    </mat-form-field>

                    <small># of grid columns that make up a row key</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('hideGridFiltering')">
                    <div class="cb-wrapper">
                        <mat-checkbox [(ngModel)]="field.hideGridFiltering"
                                      (ngModelChange)="this.handleModelChange('hideGridFiltering')"
                                      [checked]="field.hideGridFiltering"
                                      name="chkHideGridFiltering">Hide Grid Filtering</mat-checkbox>
                    </div>
                    <small>If checked, hides the grid's filter row</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('disableGridGrouping')">
                    <div class="cb-wrapper">
                        <mat-checkbox [(ngModel)]="field.disableGridGrouping"
                                      (ngModelChange)="this.handleModelChange('disableGridGrouping')"
                                      [checked]="field.disableGridGrouping"
                                      name="chkDisableGridGrouping">Disable Grid Grouping</mat-checkbox>
                    </div>
                    <small>If checked, disable grid grouping</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('hideFormFieldBody')">
                    <div class="cb-wrapper">
                        <mat-checkbox [(ngModel)]="field.hideFormFieldBody"
                                      (ngModelChange)="this.handleModelChange('hideFormFieldBody')"
                                      [checked]="field.disableGridGrouping"
                                      name="chkHideFormFieldBody">Hide Grid Body</mat-checkbox>
                    </div>
                    <small>If checked, hide the grid's body from users</small>
                </div>

                <!-- Begin properties related to 'selectOptionsFile'/cascading dropdown lists/constraints. -->
                <div class="control-wrapper" *ngIf="hasProperty('selectOptionsFile')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Named Cascading Dropdown Constraints</mat-label>

                        <mat-select name="field.siteCascadingDropdownConstraint"
                                    [disabled]="this.SiteCascadingDropdownConstraintsEmpty"
                                    [(value)]="this.SelectedCascadingDropdownConstraintId">
                            <mat-option [value]="0">--- No Constraint Selected ---</mat-option>

                            <mat-option *ngFor="let siteCascadingDropdownConstraint of this.SiteCascadingDropdownConstraints"
                                        title="{{this.getFormFieldConstraintName(siteCascadingDropdownConstraint)}}"
                                        [value]="siteCascadingDropdownConstraint.id">
                                {{this.getFormFieldConstraintName(siteCascadingDropdownConstraint)}}
                            </mat-option>
                        </mat-select>

                    </mat-form-field>
                    <small>Available cascading dropdown constraints</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('selectOptionsFile') || hasProperty('selectOptionsFileProperty')">
                    <!-- Define a hidden file input. -->
                    <input type="file"
                           #selectOptionsFile
                           class="hidden-file-input"
                           (change)="this.onSelectOptionsFileChanged($event)" />
                    <!-- Display a "Load Options from CSV ..." button for loading list options. -->
                    <button mat-stroked-button
                            (click)="this.loadOptionsFromCsvFileClicked()">
                        Load Options from CSV ...
                    </button>
                    <small>Load list options from a CSV file</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('selectOptionsFile') || hasProperty('selectOptionsFileProperty')">
                    <button mat-stroked-button
                            [disabled]="this.DisableMDSbutton"
                            (click)="this.loadOptionsFromMDSClicked()">
                        Get data from MAX via MDS ...
                    </button>
                    <small>Load options from MDS</small>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('selectOptionsFile') || hasProperty('selectOptionsFileProperty')">
                    <button mat-stroked-button
                            [disabled]="this.ClearCascadingDropdownConfigDisabled"
                            (click)="this.clearCascadingDropdownConfigClicked()">
                        Clear Configuration
                    </button>
                    <small>Clear/remove the cascading dropdown configuration</small>
                    <br />
                    <button mat-stroked-button
                            (click)="this.downloadOptionsAsCsvFileClicked()">
                        Download Options as CSV ...
                    </button>
                    <small>Download existing options to a CSV file</small>
                    <br />
                </div>

                <!-- THIS IS USED FOR BOTH NEW LIST VALUE BASED CASCADING CONSTRAINTS (USED IN FLEX FIELDS) ABD OLD CASCADING CONSTTRAINTS -->
                <div class="control-wrapper" *ngIf="hasProperty('selectOptionsFile') || hasProperty('selectOptionsFileProperty')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Cascading Dropdown Constraint Name</mat-label>

                        <button matSuffix mat-icon-button
                                title="{{this.getAssignConstraintNameButtonTitle('Assign a constraint name to this cascading dropdown configuration', this.CascadingDropdownProperties, this.SelectedCascadingDropdownConstraintId)}}"
                                class="select-options-dialog-btn"
                                [disabled]="this.FieldCascadingDropdownEmpty"
                                (click)="this.toggleEditConstraint(this.CascadingDropdownProperties, 'selectOptionsFile')">
                            <mat-icon class="edit-regular-expression-mat-icon">create</mat-icon>
                        </button>

                        <input matInput
                               #cascadingDropdownConstraintName
                               name="field.cascadingDropdownConstraintName"
                               [disabled]="this.CascadingDropdownNameDisabled"
                               placeholder="Enter a constraint name"
                               [(ngModel)]="field.cascadingDropdownConstraintName"
                               (ngModelChange)="this.handleModelChange('cascadingDropdownConstraintName')" />
                    </mat-form-field>
                    <small>A name for saving a cascading dropdown as a constraint</small>
                    <mat-error *ngIf="this.CascadingDropdownConstraintError"
                               class="range-error-message">{{this.CascadingDropdownConstraintError}}</mat-error>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('showCascadingDropdownIndicesInPreviewMode')">
                    <div class="cb-wrapper">
                        <mat-checkbox [(ngModel)]="field.transientShowCascadingDropdownIndicesInPreviewMode"
                                      (ngModelChange)="this.handleModelChange('transientShowCascadingDropdownIndicesInPreviewMode')"
                                      [checked]="field.transientShowCascadingDropdownIndicesInPreviewMode"
                                      name="chkRequired">Show Selection Indices in Preview Mode</mat-checkbox>
                    </div>
                    <small>Show cascading dropdown indices in preview mode</small>
                </div>
                <!-- End properties related to 'selectOptionsFile'/cascading dropdown lists/constraints. -->
                <!-- Begin properties used by the formula-->
                <div class="control-wrapper" *ngIf="hasProperty('formula')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Formula</mat-label>
                        <input matInput
                               name="field.formula"
                               type="text"
                               [(ngModel)]="field.formula"
                               (ngModelChange)="this.handleModelChange('formula')" />
                    </mat-form-field>
                    <small>A calculation using col1, col2, ..., for this control</small>
                    <mat-error *ngIf="field.transientFormulaError != null"
                               class="property-error-message">{{field.transientFormulaError}}</mat-error>
                </div>

                <!-- for the ValueConcatenatorFormField - we're reusing the formula field here -->
                <div class="control-wrapper" *ngIf="hasProperty('concatenation-formula')">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Concatenation Formula</mat-label>
                        <input matInput
                               name="field.formula"
                               type="text"
                               [(ngModel)]="field.formula"
                               (ngModelChange)="this.handleModelChange('formula')" />
                    </mat-form-field>
                    <div style="width:90%">
                        <small>
                            Write a formula that includes field names/display names. Ex: "https://collect.omb.gov/site/{{ '{' }}nameOfFieldOne{{ '}' }} /folder/{{ '{' }}nameOfFieldTwo{{ '}' }}"
                            <br/>
                            You can also use the special "FormId" field to include the Id of the Form.
                        </small>
                    </div>
                    <mat-error *ngIf="field.transientFormulaError != null" class="property-error-message">{{field.transientFormulaError}}</mat-error>
                </div>

                <div class="control-wrapper" *ngIf="hasProperty('isUsedToSetFormInstanceConcatenatedId')">
                    <mat-checkbox [(ngModel)]="field.isUsedToSetFormInstanceConcatenatedId"
                                  (ngModelChange)="this.handleModelChange('isUsedToSetFormInstanceConcatenatedId')"
                                  [checked]="field.isUsedToSetFormInstanceConcatenatedId"
                                  name="chkIsUsedToSetFormInstanceConcatenatedId">Used to set a Form's concatenated id.</mat-checkbox>
                    <div style="width:90%">
                        <small>(Only one field on a Form Template can serve this purpose.)</small>
                    </div>

                </div>

                    <!--
            The properties "urlBuilder" and  "urlBuilderLabel" were added for VNEXT-1419 (url builder field) but are not actually used anywhere in the UI
            There is a property in the FormField table called UrlBuilderConfigJson which has to be written to in the DB
            However, I would consider this obselete as it is superseded by ValueConcatenatorFormField which does what UrlBuilderFormFieldComponent did plus more
        -->
                    <div class="control-wrapper" *ngIf="hasProperty('urlBuilder')">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>URL Template</mat-label>
                            <input matInput name="field.transientUrlBuilderUrlTemplate" type="text" [(ngModel)]="field.transientUrlBuilderUrlTemplate" (ngModelChange)="this.handleModelChange('urlBuilder')" />
                        </mat-form-field>
                        <small>ex. https://asite.com/&lbrace;col1&rbrace;/&lbrace;col2&rbrace;?abc=&lbrace;col3&rbrace;</small>
                    </div>
                    <!-- Added for VNEXT-1419 (url builder field) -->
                    <div class="control-wrapper" *ngIf="hasProperty('urlBuilderLabel')">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Button Text</mat-label>
                            <input matInput name="field.transientUrlBuilderButtonLabel" type="text" [(ngModel)]="field.transientUrlBuilderButtonLabel" (ngModelChange)="this.handleModelChange('urlBuilderLabel')" />
                        </mat-form-field>
                        <small>If left blank, button text will be "Open"</small>
                    </div>

                    <div class="control-wrapper" *ngIf="hasProperty('roundToWholeNumber')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.roundResultToWholeNumber"
                                          (ngModelChange)="this.handleModelChange('roundToWholeNumber')"
                                          [checked]="field.roundResultToWholeNumber"
                                          name="chkRoundToWholeNumber">Round to whole number</mat-checkbox>
                        </div>
                        <small>Round result to nearest whole number</small>
                    </div>

                    <div class="control-wrapper" *ngIf="hasProperty('showDigitsWithCommaSeparators')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.showDigitsWithCommandSeparators"
                                          (ngModelChange)="this.handleModelChange('showDigitsWithCommaSeparators')"
                                          [checked]="field.showDigitsWithCommandSeparators"
                                          name="chkShowDigitCommaSeparators">Show Digit Comma Separators</mat-checkbox>
                        </div>
                        <small>Separate large numbers with commas</small>
                    </div>

                    <div class="control-wrapper" *ngIf="hasProperty('showDollarSignPrefix')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.showDollarSignPrefix"
                                          (ngModelChange)="this.handleModelChange('showDollarSignPrefix')"
                                          [checked]="field.showDollarSignPrefix"
                                          name="chkShowDollarSignPrefix">Show Dollar Sign Prefix</mat-checkbox>
                        </div>
                        <small>Show a dollar sign prefix</small>
                    </div>
                    <!-- End properties used by the formula-->

                    <div class="control-wrapper" *ngIf="hasProperty('constraint') && constraintNames && (constraintNames.length > 0)">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Constraint Type</mat-label>

                            <mat-select name="field.constraintName"
                                        [(value)]="field.constraintName"
                                        (ngModelChange)="this.handleModelChange('constraint')">
                                <mat-option *ngFor="let constraintName of this.constraintNames"
                                            title="{{constraintName}}"
                                            [value]="constraintName">
                                    {{constraintName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small>The constraint for this control</small>
                    </div>

                    <!-- Begin properties related to 'regex'/regular expression constraints. -->
                    <div class="control-wrapper" *ngIf="hasProperty('regex')">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Named Regular Expression Constraints</mat-label>

                            <mat-select name="field.siteRegularExpressionConstraint"
                                        [disabled]="this.SiteRegularExpressionConstraintsEmpty"
                                        [(value)]="this.SelectedRegularExpressionConstraintId">
                                <mat-option [value]="0">--- No Constraint Selected ---</mat-option>

                                <mat-option *ngFor="let siteRegexConstraint of this.SiteRegularExpressionConstraints"
                                            title="{{this.getFormFieldConstraintName(siteRegexConstraint)}}"
                                            [value]="siteRegexConstraint.id">
                                    {{this.getFormFieldConstraintName(siteRegexConstraint)}}
                                </mat-option>
                            </mat-select>

                        </mat-form-field>
                        <small>Available custom regular expression constraints</small>
                    </div>

                    <div class="control-wrapper" *ngIf="hasProperty('regex') || hasProperty('regexProperty')">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Custom Regular Expression Constraint</mat-label>

                            <input matInput
                                   name="field.regex"
                                   type="text"
                                   [disabled]="this.RegularExpressionConstraintSelected && this.RegularExpressionNameDisabled"
                                   [(ngModel)]="field.regex"
                                   (ngModelChange)="this.handleModelChange('regex')"
                                   (blur)="this.handleSettingsFieldBlur($event,'regex')" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Validation Error Message</mat-label>
                            <input matInput
                                   name="field.regularExpressionConstraintMessage"
                                   type="text"
                                   [disabled]="this.RegularExpressionConstraintSelected && this.RegularExpressionNameDisabled"
                                   [(ngModel)]="field.regularExpressionConstraintMessage"
                                   (ngModelChange)="this.handleModelChange('regularExpressionConstraintMessage')"
                                   (blur)="this.handleSettingsFieldBlur($event,'regularExpressionConstraintMessage')" />
                        </mat-form-field>

                        <div class="custom-regex-guidance-div">
                            <small>A custom constraint for this control</small>
                            <a href="{{this.SampleRegularExpressionsUrl}}" target="_blank" class="custom-regex-samples-a">See samples</a>
                        </div>
                    </div>

                    <div class="control-wrapper" *ngIf="hasProperty('regex') || hasProperty('regexProperty')">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Regular Expression Constraint Name</mat-label>

                            <button matSuffix mat-icon-button
                                    title="{{this.getAssignConstraintNameButtonTitle('Assign a constraint name to this regular expression', this.RegularExpressionProperties, this.SelectedRegularExpressionConstraintId)}}"
                                    class="select-options-dialog-btn"
                                    [disabled]="this.FieldRegularExpressionEmpty"
                                    (click)="this.toggleEditConstraint(this.RegularExpressionProperties, 'regex')">
                                <mat-icon class="edit-regular-expression-mat-icon">create</mat-icon>
                            </button>

                            <input matInput
                                   #regularExpressionConstraintName
                                   name="field.regularExpressionConstraintName"
                                   [disabled]="this.RegularExpressionNameDisabled"
                                   placeholder="Enter a constraint name"
                                   [(ngModel)]="field.regularExpressionConstraintName"
                                   (ngModelChange)="this.handleModelChange('regularExpressionConstraintName')" />
                        </mat-form-field>
                        <small>A name for saving the regular expression as a constraint</small>
                        <mat-error *ngIf="this.RegularExpressionConstraintError"
                                   class="range-error-message">{{this.RegularExpressionConstraintError}}</mat-error>
                    </div>
                    <!-- End properties related to 'regex'/regular expression constraints. -->

                    <div class="control-wrapper" *ngIf="hasProperty('readOnly')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.readOnly"
                                          (ngModelChange)="this.handleModelChange('readOnly')"
                                          [checked]="field.readOnly"
                                          name="chkReadOnly">Read Only</mat-checkbox>
                        </div>
                        <div *ngIf="hasProperty('footer')"><small>Do not allow users to edit fields in this grid (paste allowed)</small></div>
                        <div *ngIf="!hasProperty('footer')"><small>Do not allow users to edit this field's value</small></div>
                    </div>
                    <!--
             10-05-2020 note:  the following <div/> will be completed when
             new field 'showPreview' is added to model class FormField.
        -->
                    <div class="control-wrapper" *ngIf="hasProperty('showPreview')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.showPreview"
                                          (ngModelChange)="this.handleModelChange('showPreview')"
                                          [checked]="field.showPreview"
                                          name="chkShowPreview">Show Preview</mat-checkbox>
                        </div>
                        <small>Display a formatted preview of this field's value</small>
                    </div>

                    <!-- Begin another property used by decimal form fields. -->
                    <div class="control-wrapper" *ngIf="hasProperty('showTrailingZeroesAfterDecimalPoint')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.showTrailingZeroesAfterDecimalPoint"
                                          (ngModelChange)="this.handleModelChange('showTrailingZeroesAfterDecimalPoint')"
                                          [checked]="field.showTrailingZeroesAfterDecimalPoint"
                                          name="chkShowTrailingZeroesAfterDecimalPoint">Show Trailing Zeroes</mat-checkbox>
                        </div>
                        <small>Show trailing zeroes following the decimal point?</small>
                    </div>
                    <!-- End another property used by decimal form fields. -->

                    <div class="control-wrapper" *ngIf="hasProperty('footer')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.showFooter"
                                          (ngModelChange)="this.handleModelChange('showFooter')"
                                          [checked]="field.showFooter"
                                          name="chkShowFooter">Show Footer</mat-checkbox>
                        </div>
                        <small>Display a footer with numeric totals</small>
                    </div>


                    <div *ngIf="hasProperty('numDisplayRows')"
                         class="control-wrapper">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Display Rows</mat-label>

                            <!-- Note:  need to set attribute 'name' on the following <mat-select/> to avoid an ngModel error. -->
                            <mat-select name="field.displayRows"
                                        [(ngModel)]="field.displayRows"
                                        (ngModelChange)="this.handleModelChange('numDisplayRows')">
                                <mat-option *ngFor="let numDisplayRows of this.displayRowsValues"
                                            [value]="numDisplayRows">
                                    {{numDisplayRows}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small>The number of rows to display</small>
                    </div>

                    <!--TEAMS-424: KLW - If the Form Field has the property for footnote then add accordingly-->
                    <div class="control-wrapper" *ngIf="hasProperty('footnote')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.hasFootnote"
                                          (ngModelChange)="this.handleModelChange('footnote')"
                                          [checked]="field.hasFootnote"
                                          name="chkHasFootnote">Has Footnote?</mat-checkbox>
                        </div>
                    </div>

                    <!--VNEXT-384: KLW - Implementing Autocomplete-->
                    <div class="control-wrapper" *ngIf="hasProperty('autocomplete')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.autocomplete"
                                          (ngModelChange)="this.handleModelChange('autocomplete')"
                                          [checked]="field.autocomplete"
                                          name="chkAutocomplete">Autocomplete</mat-checkbox>
                        </div>
                    </div>

                    <!--VNEXT-519: KLW - Refinements to the Type ahead functionality-->
                    <div class="sub-control-wrapper">
                        <div class="control-wrapper" *ngIf="hasProperty('autocomplete') && field.autocomplete == true">
                            <div class="cb-wrapper">
                                <mat-slide-toggle [(ngModel)]="field.autocomplete_StartsWith"
                                                  (ngModelChange)="this.handleModelChange('autocomplete_StartsWith')"
                                                  [checked]="field.autocomplete_StartsWith"
                                                  name="chkAutocomplete_StartsWith">Results Start With</mat-slide-toggle>
                            </div>
                        </div>

                        <div class="control-wrapper" *ngIf="hasProperty('autocomplete') && field.autocomplete == true">
                            <div class="cb-wrapper">
                                <mat-slide-toggle [(ngModel)]="field.autocomplete_Contains"
                                                  (ngModelChange)="this.handleModelChange('autocomplete_Contains')"
                                                  [checked]="field.autocomplete_Contains"
                                                  name="chkAutocomplete_Contains">Results Contain</mat-slide-toggle>
                            </div>
                        </div>
                        <mat-error *ngIf="this.AutocompleteOptionsError"
                                   class="range-error-message">{{this.AutocompleteOptionsError}}</mat-error>
                    </div>

                    <!-- 06-15-2023:  begin new grid-related properties. -->
                    <div class="control-wrapper" *ngIf="hasProperty('gridColumnBehavior')">
                        <mat-label>Grid Column Behavior</mat-label>
                        <mat-radio-group aria-labelledby="example-radio-group-label"
                                         class="grid-column-behavior-radio-group"
                                         name="field.gridColumnBehavior"
                                         [(ngModel)]="field.gridColumnBehavior">
                            <mat-radio-button *ngFor="let columnBehavior of this.GridColumnBehaviors"
                                              class="grid-column-behavior-radio-button"
                                              [value]="columnBehavior.behaviorValue">
                                {{columnBehavior.behaviorTitle}}
                            </mat-radio-button>
                        </mat-radio-group>
                        <small class="grid-column-behavior-small">Configure where a grid cell displays</small>
                    </div>

                    <div class="control-wrapper" *ngIf="hasProperty('gridColumnRoles')">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Roles that can edit this column</mat-label>
                            <input matInput
                                   name="field.gridColumnCanBeEditedByRoles"
                                   [disabled]="false"
                                   placeholder="Role(s) allowed to edit this cell"
                                   [(ngModel)]="field.gridColumnCanBeEditedByRoles"
                                   (ngModelChange)="this.handleModelChange('gridColumnRoles')"
                                   (blur)="this.handleSettingsFieldBlur($event,'gridColumnRoles') " />
                        </mat-form-field>

                        <small>
                            Separate roles(s) by a | (ex. Contributor|Reviewer).<br />
                            (If no roles entered, anyone who can edit the Form can edit the column.)
                        </small>
                    </div>
                    <!-- 06-15-2023:  end new grid-related properties. -->

                    <div class="control-wrapper" *ngIf="hasProperty('gridColumnViewRoles')">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Roles that can view this column</mat-label>
                            <input matInput
                                   name="field.gridColumnCanBeViewedByRoles"
                                   [disabled]="false"
                                   placeholder="Role(s) which can view this column"
                                   [(ngModel)]="field.gridColumnCanBeViewedByRoles"
                                   (ngModelChange)="this.handleModelChange('gridColumnViewRoles')"
                                   (blur)="this.handleSettingsFieldBlur($event,'gridColumnViewRoles') " />
                        </mat-form-field>

                        <small>
                            Separate roles(s) by a | (ex. Contributor|Reviewer).<br />
                            (If no roles entered, anyone who can view the Form can view the column.)
                        </small>
                    </div>

                    <!-- Begin property for VNEXT-1515, disabling grid row deletes row non-admins. -->
                    <div class="control-wrapper" *ngIf="hasProperty('disableGridRowDeleteForNonAdmins')">
                        <div class="cb-wrapper">
                            <mat-checkbox [(ngModel)]="field.disableGridRowDeleteForNonAdmins"
                                          (ngModelChange)="this.handleModelChange('disableGridRowDeleteForNonAdmins')"
                                          [checked]="field.disableGridRowDeleteForNonAdmins"
                                          name="chkDisableGridRowDeleteForNonAdmins">Disable Grid Row Delete</mat-checkbox>

                            <small>
                                Disable grid row deletions for non-admins.
                            </small>
                        </div>
                    </div>
                    <!-- End property for VNEXT-1515, disabling grid row deletes row non-admins. -->

            </mat-expansion-panel>
        </mat-accordion>
        <div class="spacer"></div> <!--gap so buttons do not cover lowest part of bottom panel-->
        <div class="button-wrapper" id="buttonWrapperDiv">
            <button mat-raised-button type="submit" class="button-primary" [disabled]="this.DisableSave" (click)="saveClicked()">Apply</button>
            &nbsp;&nbsp;
            <button mat-raised-button type="button" class="button-secondary" (click)="cancelClicked()">Cancel</button>
        </div>

    </form>
</div>
